import React from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { IconEye, IconEyeOff, IconArrowBackUp } from "@tabler/icons-react";
import { cn } from "@/lib/utils";

dayjs.extend(relativeTime);

export default function StatusIcon(props) {
  const statusIconMap = {
    OPEN: {
      Icon: IconEye,
      className: "",
      style: {},
      title: `Seen: ${dayjs(Math.floor(props.value)).fromNow()}`,
    },
    NOT_OPEN: {
      Icon: IconEyeOff,
      className: "text-muted-foreground",
      style: { opacity: 0.4 },
      title: "Not seen",
    },
    REPLIED: {
      Icon: IconArrowBackUp,
      className: "text-green-600",
      style: {},
      title: `Picks sent: ${dayjs(Math.floor(props.repliedAt)).fromNow()}`,
    },
    NOT_REPLIED: {
      Icon: IconArrowBackUp,
      className: "text-muted-foreground",
      style: { opacity: 0.4 },
      title: "No picks",
    },
  };

  let tag = "";
  switch (props.variant) {
    case "open":
      tag = props.value ? "OPEN" : "NOT_OPEN";
      break;

    case "reply":
      tag = props.value ? "REPLIED" : "NOT_REPLIED";
      break;

    default:
      break;
  }

  const { Icon, className, style, title } = statusIconMap[tag];

  return (
    <Icon
      className={cn("size-4", className, props.className)}
      style={style}
      title={title}
    />
  );
}
